import { render, staticRenderFns } from "./ListLimitationForm.vue?vue&type=template&id=17dfaee1&"
import script from "./ListLimitationForm.vue?vue&type=script&lang=js&"
export * from "./ListLimitationForm.vue?vue&type=script&lang=js&"
import style0 from "./ListLimitationForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports